'use client';

import { useTranslations } from 'next-intl';
import {
  MessageSquare,
  Images,
  Palette,
  ImagePlus,
  DraftingCompass,
} from 'lucide-react';
import { Typography } from '@/shared/ui/shadcn/typography';

interface OnboardingEmptyStateProps {
  icon: 'goals' | 'angles' | 'references' | 'concepts' | 'albums';
  step: number;
  description: string;
}

const iconMap = {
  goals: MessageSquare,
  angles: Images,
  references: Palette,
  concepts: ImagePlus,
  albums: DraftingCompass,
};

export function OnboardingEmptyState({
  icon,
  step,
  description,
}: OnboardingEmptyStateProps) {
  const t = useTranslations('onboarding');
  const Icon = iconMap[icon];

  const lines = description.split('\n');

  return (
    <div className="h-full w-full flex flex-col items-center justify-center gap-2 px-4">
      <Icon className="h-9 w-9 text-muted-foreground/50" strokeWidth={1.5} />
      <div className="text-center">
        <Typography
          variant="muted"
          className="text-list-item-value text-muted-foreground/70"
        >
          {t('step', { number: step })}
        </Typography>
        <Typography
          variant="muted"
          className="text-card-meta text-muted-foreground/60"
        >
          {lines.map((line, i) => (
            <span key={i}>
              {line}
              {i < lines.length - 1 && <br />}
            </span>
          ))}
        </Typography>
      </div>
    </div>
  );
}
